import React from 'react'
import abt360 from '../../../../assets/img/client_mn.webp'
import { Link } from 'react-router-dom'

function Aboutclient() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li>Clients</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Our <span>Clients</span></h2>
              <p>Over the years we have  established ourselves as the leading service provider for Mobile  Application Development, Website Design & Development, Web and  Graphic Design, E-Commerce Development, Software as a Solution (Saas -  cloud solution), Digital Transformation and Product Engineering company  based out of Chandigarh.</p>
            </div> 
           <div className='hmslder-img'>
            <img src={abt360} alt='Our Clients' width={1200} height={600} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default Aboutclient
